<!-- PAGE HEADER -->

<div class="page-header">
  <h2>Vouchers & Agreements</h2>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>
<div class="container">
  <div>
    <h3>Vouchers</h3>
  </div>
  <div>
    <p-table [responsive]="true" [value]="voucherList" [paginator]="true" [rows]="10" sortMode="multiple">

      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th>
            Redemption Period
          </th>
          <th>
            Type
          </th>
          <th>
            Language
          </th>
          <th>
            Status
          </th>
          <th>
            Open or save
          </th>
        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-voucher>
        <tr>
          <td>
            {{ voucher.createdDate | date:'MM/dd/yyyy' }} -
            {{ voucher.expiryDate | date:'MM/dd/yyyy' }}
          </td>
          <td>{{ voucher.fileType }}</td>
          <td>{{ voucher.fileLanguage === 'EN' ? 'English' : 'Spanish' }}</td>
          <td>{{ getStatusLabel(voucher.voucherProgramStatus) }}</td>
          <td>
            <!-- Open in Browser -->
            <i class="pi pi-eye action-icon" title="Open" (click)="openFile(voucher.fileName, voucher.fileType)">
            </i>

            <!-- Download -->
            <i class="pi pi-download action-icon" title="Download"
              (click)="downloadFile(voucher.fileName, '3')">
            </i>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
  <div>
    <h3>Agreements</h3>
  </div>
  <div>
    <p-table [responsive]="true" [value]="agreementList" [paginator]="true" [rows]="10" sortMode="multiple">

      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th>Created Date</th>
          <th>Type</th>
          <th>Status</th>
          <th *ngIf="isSuperAdmin()">Remove</th>
          <th>Open or save</th>
        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-voucher>
        <tr>
          <td>{{ voucher.createdDate | date:'MM/dd/yyyy' }}</td>
          <td>Voucher</td>
          <td>{{ getStatusLabel(voucher.voucherProgramStatus) }}</td>
          <td *ngIf="isSuperAdmin()">
            <i class="pi pi-trash action-icon" title="Remove" (click)="confirmDelete(voucher)">
            </i>
          </td>
          <td>
            <i *ngIf="voucher.voucherProgramStatus == 'Completed'" class="pi pi-eye action-icon" title="Open" (click)="openFile(voucher.fileName, voucher.fileType)">
            </i>

            <i *ngIf="voucher.voucherProgramStatus == 'Completed'" class="pi pi-download action-icon" title="Download"
              (click)="downloadFile(voucher.fileName, '3')">
            </i>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

<p-dialog header="{{ dialogSummary }}" [styleClass]="'success-dialog error'" [(visible)]="locListModalDlg"
  [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
  [breakpoints]="{ '640px': '95vw' }">

  <div class="dialog-body" [innerHTML]="dialogMsg"></div>

  <ng-template pTemplate="footer">
    <div class="actions">
      <ng-container>
        <button type="button" class="button-primary" (click)="okClicked()">
          Ok
        </button>
      </ng-container>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Are you sure?" [(visible)]="confirmDeleteDialog" [modal]="true" [closable]="false"
  [dismissableMask]="false" [style]="{ width: '500px' }">

  <div class="dialog-body">
    This will permanently remove the agreement and all associated vouchers.
    This action cannot be undone.
  </div>

  <ng-template pTemplate="footer">
    <div class="actions">
      <button type="button" class="button-secondary" (click)="confirmDeleteDialog = false">
        Cancel
      </button>

      <button type="button" class="button-primary" (click)="deleteAgreement()">
        Continue
      </button>
    </div>
  </ng-template>
</p-dialog>